/** Sleep generic. */
const sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

export type TypingLatencyOpts = {
  base?: number;     // ms minim
  perChar?: number;  // ms per caracter (cap la maxExtra)
  maxExtra?: number; // plafon pentru perChar
  jitter?: number;   // zgomot random
};

/** Calculează o latență "umană". */
export function computeTypingLatency(
  text: string,
  { base = 700, perChar = 8, maxExtra = 500, jitter = 250 }: TypingLatencyOpts = {}
): number {
  const extra = Math.min(text.length * perChar, maxExtra);
  const spice = Math.floor(Math.random() * jitter);
  return base + extra + spice; // ~700..1450ms tipic
}

/** Așteaptă latența calculată pentru text. */
export async function typingDelay(text: string, opts?: TypingLatencyOpts) {
  const ms = computeTypingLatency(text, opts);
  await sleep(ms);
}

/** Delay simplu forțat. */
export function forceDelay(ms = 200) {
  return sleep(ms);
}

/**
 * Așteaptă promisiunea + latența de typing, fără short-circuit pe eroare.
 * Opțional, ține indicatorul aprins încă "tailAfterMs" după ce s-a terminat.
 */
export async function withTypingDelay<T>(
  promise: Promise<T>,
  text: string,
  opts?: TypingLatencyOpts,
  tailAfterMs = 0
): Promise<T> {
  const [result] = await Promise.allSettled([promise, typingDelay(text, opts)]);
  if (tailAfterMs > 0) await forceDelay(tailAfterMs);

  if (result.status === "rejected") {
    throw result.reason;
  }
  return result.value;
}

/**
 * Garantează că o operație durează *cel puțin* `ms` (și pe succes, și pe eșec).
 */
export async function withMinDuration<T>(promise: Promise<T>, ms: number) {
  const [res] = await Promise.allSettled([promise, forceDelay(ms)]);
  if (res.status === "rejected") throw res.reason;
  return res.value;
}
